<script setup>
  // import Util from '@/services/browser/Util'
  import Hft_PlayNow from '@/components/microsites/HeadingForTomorrow/components/Hft_PlayNow.vue'
  import { useWindowSize } from '@vueuse/core'
  import { computed, ref } from 'vue'
  const { width } = useWindowSize()
  const isMobileMenuOpen = ref(false)
  const mobileMenuAnimationReveal = ref(false)
  const props = defineProps({
    navItems: {
      type: Array,
      required: true,
    },
  })

  const navRef = ref(null)

  const scrollToSection = (id) => {
    closeMenu()
    const element = document.getElementById(id)
    if (element) {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - navRef.value.getBoundingClientRect().height * 1.5, // Adjust offset for sticky nav
        behavior: 'smooth',
      })
    }
  }
  const openMenu = () => {
    isMobileMenuOpen.value = true
    setTimeout(() => {
      mobileMenuAnimationReveal.value = true
    }, 10)
  }
  const closeMenu = () => {
    mobileMenuAnimationReveal.value = false
    setTimeout(() => {
      isMobileMenuOpen.value = false
    }, 300)
  }

  const isMobile = computed(() => width.value < 480)
</script>
<template>
  <div v-if="isMobile" ref="navRef" class="m-headingForT-nav">
    <div class="m-headingForT-nav__menu-icon" @click="openMenu"></div>
  </div>
  <div
    v-if="isMobile"
    :class="`m-headingForT-nav-content ${isMobileMenuOpen ? 'show' : ''} ${
      mobileMenuAnimationReveal ? 'animate-show' : ''
    }`"
    data-section-number="0"
    data-section-name="Mobile Nav"
  >
    <div class="m-headingForT-nav-content__close-icon" @click="closeMenu"></div>
    <div class="m-headingForT-nav-content__menu">
      <Hft_PlayNow v-ga-event="'Play Now'" class="m-headingForT-nav__playnow" />
      <div
        v-for="item in props.navItems"
        :key="item.id"
        v-ga-event="item.name"
        class="m-headingForT-nav-content__menu-item"
        @click="scrollToSection(item.id)"
      >
        {{ item.name }}
      </div>
      <a v-ga-event="'Go to Main Site'" href="/maplestory" class="m-headingForT-nav-content__go-main-link"
        >Go to Main Site</a
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
  @use '@/assets/scss/microsites/headingfortomorrow/variables.scss' as *;
  .m-headingForT-nav {
    width: 100%;
    height: 10vw;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 20;
    background: #0f648d;
    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 4px;
      background: #ffb90d;
      bottom: 0;
      transform: translateY(100%);
    }
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      background: white;
      bottom: -4px;
      transform: translateY(100%);
    }
  }
  .m-headingForT-nav__menu-icon {
    width: 7vw;
    height: 5vw;
    background: url('~@/assets/images/microsites/demonslayer/_components/mobile-nav/menu-icon.png') no-repeat center
      center / 100% auto;
    position: absolute;
    top: 50%;
    left: 3vw;
    transform: translateY(-50%);
  }
  .m-headingForT-nav-content {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(#0f648d, 0.9);
    display: none;
    z-index: 100;
    opacity: 0;
    transform: scale(1.1);
    transition: all 0.3s;
    &.show {
      display: block;
    }
    &.animate-show {
      opacity: 1;
      transform: scale(1);
    }
  }
  .m-headingForT-nav-content__menu {
    padding-top: 35vw;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    gap: 12vw;
  }
  .m-headingForT-nav-content__menu-item {
    color: $titleColor;
    font-size: 8vw;
    &:hover {
      color: $accentColor;
    }
  }
  .m-headingForT-nav-content__go-main-link {
    color: white;
    margin-top: 8vw;
    font-size: 6vw;
    text-decoration: none;
    text-transform: uppercase;
  }
  .m-headingForT-nav-content__close-icon {
    position: absolute;
    width: 7.5vw;
    height: 7.5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/_components/nav/close-icon.png') no-repeat center
      center / 100% auto;
    position: absolute;
    top: 3vw;
    right: 3vw;
  }
</style>
